import React from 'react';
import { footnoteFactory } from 'components/footnote';
import ImageBox from 'components/image-box';
import Page from 'structure/page';
import thCenturyImage from './thcentury.png';
import staysImage from './Stays1830.png';
import victorianImage from './victorian.png';

const fn = footnoteFactory(({children}) => (
  <footer style={{ clear: 'both' }} className="footnotes">{children}</footer>));

export const History = (props) => (
  <Page title="History of the Corset" {...props}>
    <section>
      <h3>Elizabethan</h3>
      <p>An early form of the corset was the Elizabethan "pair of bodies" which provided support and flattened the bust.
        It also provided a foundation garment over which a gown's bodice (also called a pair of bodies) was worn.
        There are two surviving examples today.
        One is from the grave of Pfalzgrafin Dorothea Sabina von Neuberg from 1598 and the other is from Queen
        Elizabeth I's effigy in 1603.
        {fn("Arnold, Janet. Queen Elizabeth's Wardrobe Unlock'd. p. 145-146")}
        {fn("Harvey, Anthony and Richard Mortimer (editors). The Funeral Effigies of Westminster Abbey (article by Janet Arnold.)")}
      </p>
    </section>
    <hr />
    <section>
      <h3>17th and 18th Centuries</h3>
      <ImageBox width="142px" height="150px" image={thCenturyImage} caption="18th century stays" left />
      <p>From the end of the 17th century corsets or "stays" had changed slightly to give the wearer a more slender
        silhouette. By the mid 18th century stays had curved whalebone to shape the front of the bust and across the
        back to flatten the shoulder blades. They were often covered in beautiful fabric or embroidery.
        {fn("Waugh, Norah. Corsets and Crinolines. p. 37-41.")}

      </p>
    </section>
    <hr />
    <section>
      <h3>19th Century</h3>
      <ImageBox width="150px" height="117px"  image={staysImage} caption="1830's stays" right/>
      <p>In the beginning of the 19th century stays were unfashionable and those that could did without them. However, those who were too large for the fashionable flowing, formfitting gowns and needed something to control their excess flesh continued to wear stays. When they came back into fashion around 1809-1810 they were called by their modern name: the corset. For the first time it was not a rigid body but a curved one. It was made "... from strong cotton material (jean, later know as coutil)".
      {fn("Waugh, Norah. Corsets and Crinolines. p. 79.")}
      </p>
      <ImageBox width="98px" height="150px" image={victorianImage} caption='Victorian corset' left />
      <p>It had shoulder straps until the 1840s and later, if the wearer needed them, for a little more support for the bust. Several new inventions helped corset manufacture during the 19th century: metal eyelets in 1828, the first front opening steel busk in 1829 and the spoon busk in 1873. White corsets were considered more ladylike. Corsets were also made in grey, putty, red and black but were always lined in white.
      {fn("Waugh, Norah. Corsets and Crinolines. p. 75-83.")}
      </p>
      </section>
      {fn()}
  </Page>
);

export default History;



// WEBPACK FOOTER //
// ./src/pages/history/history.js